import * as actions from "./borrower.withdrawal.actions";
import update from "immutability-helper";

let initialState = {
  create: {
    fetching: false,
    fetched: false,
    error: null,
    data: {},
  },
  withdrawals: {
    fetching: false,
    fetched: false,
    error: null,
    data: {},
  },
  confirm: {
    fetching: false,
    fetched: false,
    error: null,
    data: {},
  },
};

const borrowerWithdrawal = (state = initialState, action) => {
  switch (action.type) {
    case actions.CREATE_BORROWER_SURPLUS_WITHDRAWAL_REQUEST:
    case actions.CREATE_BORROWER_WITHDRAWAL_REQUEST:
      return update(state, {
        create: {
          fetching: { $set: true },
          fetched: { $set: false },
        },
      });

    case actions.CREATE_BORROWER_SURPLUS_WITHDRAWAL_SUCCESS:
    case actions.CREATE_BORROWER_WITHDRAWAL_SUCCESS:
      return update(state, {
        create: {
          fetching: { $set: false },
          fetched: { $set: true },
          data: { $set: action.response },
        },
      });

    case actions.CREATE_BORROWER_SURPLUS_WITHDRAWAL_ERROR:
    case actions.CREATE_BORROWER_WITHDRAWAL_ERROR:
      return update(state, {
        create: {
          fetching: { $set: false },
          fetched: { $set: false },
          error: { $set: action.error },
        },
      });

    case actions.FETCH_BORROWER_WITHDRAWALS_REQUEST:
      return update(state, {
        withdrawals: {
          fetching: { $set: true },
          fetched: { $set: false },
        },
      });

    case actions.FETCH_BORROWER_WITHDRAWALS_SUCCESS:
      return update(state, {
        withdrawals: {
          fetching: { $set: false },
          fetched: { $set: true },
          data: {
            $merge: action.response.length
              ? { [action.response[0].BorrowerId]: action.response }
              : {},
          },
        },
      });

    case actions.FETCH_BORROWER_WITHDRAWALS_ERROR:
      return update(state, {
        withdrawals: {
          fetching: { $set: false },
          fetched: { $set: false },
          error: { $set: action.error },
        },
      });

    case actions.CONFIRM_BORROWER_WITHDRAWAL_REQUEST:
      return update(state, {
        confirm: {
          fetching: { $set: true },
          fetched: { $set: false },
        },
      });

    case actions.CONFIRM_BORROWER_WITHDRAWAL_SUCCESS:
      return update(state, {
        confirm: {
          fetching: { $set: false },
          fetched: { $set: true },
          data: { $set: action.response },
        },
      });

    case actions.CONFIRM_BORROWER_WITHDRAWAL_ERROR:
      return update(state, {
        confirm: {
          fetching: { $set: false },
          fetched: { $set: false },
          error: { $set: action.error },
        },
      });

    default:
      return state;
  }
};

export default borrowerWithdrawal;
